<template>
  <vue-popover :type="popoverType">
    <div class="popover-list">
      <button class="popover-item" @click="handle('report-orders-labels')">
        <span class="p-2 mr-2 text-gray bg-gray-darkest rounded-full inline-flex items-center">
          <svgicon name="business-note-solid"></svgicon>
        </span>
        <span class="uppercase tracking-wide text-xs">Etiquettes</span>
      </button>
     <button class="popover-item" @click="handle('report-orders-lab')">
        <span class="p-2 mr-2 text-gray bg-gray-darkest rounded-full inline-flex items-center">
          <svgicon name="business-note-solid"></svgicon>
        </span>
        <span class="uppercase tracking-wide text-xs">Laboratoire</span>
      </button>
     <button class="popover-item" @click="handle('report-orders-vendor')">
        <span class="p-2 mr-2 text-gray bg-gray-darkest rounded-full inline-flex items-center">
          <svgicon name="business-note-solid"></svgicon>
        </span>
        <span class="uppercase tracking-wide text-xs">Vendeur</span>
      </button>
    </div>
    <vue-button slot="trigger" icon="business-note-solid" class="btn btn-primary btn-outline" :class="btnClass">Rapports</vue-button>
  </vue-popover>
</template>

<script>
/* globals moment */
export default {
  props: {
    btnClass: {
      type: String,
      default: null,
    },
    popoverType: {
      type: String,
      default: null,
    },
  },

  methods: {
    handle(report) {
      const params = new URLSearchParams(window.location.search);

      if (params.has('pickupDate')) {
        const [start, end] = params
          .get('pickupDate')
          .split(',')
          .map(date => moment(date));

        if (end.diff(start, 'days') > 31) {
          return this.$notify({
            type: 'error',
            title: 'Erreur',
            text:
              'Vous ne pouvez pas générer un rapport pour une période supérieur à 31 jours.',
          });
        }
      }

      return this.$modal.open(report);
    },
  },
};
</script>
